export type Bonus = {
  number: string
  title: string
  body: string
  accent: string
  /** Optional rendered cover. When empty, a code-drawn cover is shown. */
  cover?: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The 10-Minute Class Setup Checklist™',
    body: 'Walk into any session fully prepared in 10 minutes or less: session focus, structure, equipment scan, a regression for every risky move, your opening line and a 60-second backup plan. Printable plus a phone version.',
    accent: 'bg-gold',
  },
  {
    number: '02',
    title: 'The Exercise Swap Matrix™',
    body: 'Instantly replace any exercise when equipment, space or client ability changes — squat, hinge, push, pull and core, each in beginner, standard and advanced versions, plus no-equipment and small-space tables.',
    accent: 'bg-[#1C7A45]',
  },
  {
    number: '03',
    title: 'The Bootcamp Opening Scripts Pack™',
    body: 'Ready-to-read openings for strength days, conditioning days, beginners and finishers, plus safety and scaling scripts and a fill-in-the-blank builder. Sound prepared from the first 60 seconds.',
    accent: 'bg-[#5B2AA5]',
  },
  {
    number: '04',
    title: 'The Client Level Decoder™',
    body: 'One class, three levels, zero confusion. Beginner, regular and advanced profiles, a movement readiness checklist, scaling by pattern and by variable, and a regress-or-progress decision tree.',
    accent: 'bg-[#2F6FB5]',
  },
  {
    number: '05',
    title: 'The Done-For-You Finisher Bank™',
    body: '30 ready-to-coach finishers — bodyweight, partner, team, low-equipment, strength and low-impact — with a selection guide by class goal and printable finisher cards.',
    accent: 'bg-crimson',
  },
]
